import AutocompleteObjectV2 from "../../component/AutocompleteObjectV2";
import {searchDepartments} from "../services/reportAssignment";
import {CRITERIA_TYPE_NAME} from "../../danh-muc/const/constant";
import {columnNamesTypeTableCollapse} from "@oceantech/oceantech-ui";

export const Columns = (props: any) => {
  const {handleChangeRowInput} = props;
  const columns: columnNamesTypeTableCollapse[] = [
  {
    name: "STT",
    field: "stt",
    headerStyle: {
      minWidth: 50,
      maxWidth: 50,
    },
    cellStyle: {
      textAlign: "center",
    },
    render: (row: any, index: number, stt: number | undefined) => stt,
  },
    {
      name: "Loại",
      field: "type",
      headerStyle: {
        minWidth: 100,
        maxWidth: 100,
      },
      cellStyle: {
        justifyContent: "center",
      },
      render: (row: any) => CRITERIA_TYPE_NAME[row.type as keyof typeof CRITERIA_TYPE_NAME] || '',
    },
  {
    name: "Tên",
    field: "name",
    headerStyle: {
      minWidth: 500,
    },
    cellStyle: {
      textAlign: "left",
    },
    render: (row: any) => row.name || '',
  },
  {
    name: "Phòng ban",
    field: "department",
    headerStyle: {
      minWidth: 200,
    },
    cellStyle: {
      textAlign: "left",
    },
    render: (row: any, index: number) => {
      return (
        <AutocompleteObjectV2
          options={[]}
          searchFunction={searchDepartments}
          searchObject={{}}
          name={"result"}
          value={row?.result ?? null}
          getOptionLabel={(option: any) => option.name}
          onChange={(options: any) => handleChangeRowInput(index, options.value, "result")}
          className="autocomplete-custom-renderform pl-5 radius spaces min-w-200 h-29"
          isClearable={false}
        />
      )
    },
  },
];
  return columns
}